import React from "react";
import { useLocation } from "react-router-dom";
import MainContentCard from "../../Home/MainContentCard";
import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";

import UpdateVisitChild from "./UpdateVisitChild";
import "./UpdateVisit.css";

const UpdateVisit = () => {
  const { state } = useLocation();
  let currentRecord = state.visit;
  let patientRecordId = state.patientRecordId;
  let patientProfileData = state.patientProfileData;
  console.log("this is currentRecord", currentRecord);
  console.log("this is patientRecordId", patientRecordId);
  console.log("this is patientProfileData", patientProfileData);
  return (
    <MainContentCard>
      {/* {JSON.stringify(state)} */}
      <ErrorBoundaryRoutes page="CreateVisitChild" route="/create-visit">
        <UpdateVisitChild
          currentRecord={currentRecord}
          patientRecordId={patientRecordId}
          patientProfileData={patientProfileData}
        />
      </ErrorBoundaryRoutes>
    </MainContentCard>
  );
};

export default UpdateVisit;
